import servicesConfig, { CustomAxiosHeaders } from '../config/services'
import { requests } from '.'
import { getHeader } from '../util/axios_helper'
import { AxiosResponse } from 'axios'

// Configure request setup
const serviceName = 'UnauthenticatedService'
const host = servicesConfig.Oauth
const opts: CustomAxiosHeaders = { host, serviceName, skipInterceptor: true }
const headers = getHeader()
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

// Helper function to handle response
const responseBody = (res: AxiosResponse) => res.data

const UnauthenticatedService = {
  signout: async (apiKey: string, refreshTokenV1: string, refreshTokenV2: string): Promise<void> => {
    try {
      await request().post(
        '/auth/signout',
        {},
        {
          headers: {
            ...headers,
            authorization: `Bearer ${apiKey}`,
            'refresh-token-v1': refreshTokenV1,
            'refresh-token-v2': refreshTokenV2,
          },
        }
      )
    } catch (error) {
      console.error('Error signing out from unauthenticated service', error)
    }
  },
  loginWithToken: async (params: any): Promise<AxiosResponse> => {
    try {
      return await request().post('/auth/login/token', params, {
        headers: {
          ...headers,
          source: 'WEB_USER',
          channel: 'APP',
        },
      })
    } catch (error) {
      console.error('Error signing in with token', error)
      throw error
    }
  },
  validateDesktopMagicToken: async(params: {  
    magicToken: string
    deviceId: string
    deviceType: string
    deviceName: string
  }): Promise<AxiosResponse> => {
    try {
      return await request().post('/auth/desktop/validate', params).then(responseBody)
    } catch (error) {
      console.error('Error validating desktop magic token', error)
      throw error
    }
  }
}
export default UnauthenticatedService
